/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./functions');
require('bootstrap/dist/js/bootstrap.bundle');
require('./bootstrap-material-design.min');
require('perfect-scrollbar');
window.moment = require('moment');
require('datetime-moment');

// Plugin for Sweet Alert
window.Swal = require('sweetalert2');

// Forms Validations Plugin
require('jquery-validation');

require('bootstrap-select');

require('./plugins/bootstrap-datetimepicker.min');

require('jasny-bootstrap/dist/js/jasny-bootstrap.min');

// DATATABLES
window.JSZip = require('jszip');
require('datatables.net-bs5');
import 'datatables.net-buttons-bs5';
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.print');
require('datatables.net-buttons/js/buttons.flash.min');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-responsive');

require('corejs-typeahead/dist/typeahead.bundle');
window.Bloodhound = require('corejs-typeahead/dist/bloodhound');
require('bootstrap4-tagsinput/tagsinput')

$.fn.dataTable.moment('DD/MM/YYYY HH:mm:ss');

window.inputmask = require('inputmask/dist/inputmask/jquery.inputmask');

import autocomplete from "autocompleter";
window.autocomplete = autocomplete;

require('./plugins/bootstrap-notify');

require('./material-dashboard');
require('./plugins/jquery.maskMoney.min');
require('./plugins/jquery.transfer.js');
require('./plugins/select2.min');
window.currency = require('./plugins/currency.min');

import Webcam from 'webcam-easy';
window.Webcam = Webcam;

require('moment/moment');
require('daterangepicker/daterangepicker');
require('summernote/dist//summernote.js');
require('summernote/dist/lang/summernote-pt-BR.min.js');
require('flickity');
require('bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox');
require('smartwizard/dist/js/jquery.smartWizard.min');
require('croppie');
require('./zoop');
require('./croppie');
require('./datatables.js');
require('./datatablesPackageSale.js');

// Chart JS
import Chart from 'chart.js/auto';
window.Chart = Chart;
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

//  Plugin for the DateTimePicker, full documentation here: https://eonasdan.github.io/bootstrap-datetimepicker/ -->
//window.datetimepicker = require('eonasdan-bootstrap-datetimepicker');


import Sortable from 'sortablejs/modular/sortable.complete.esm';
window.Sortable = Sortable;

import datatablesPtBr from './jquery-datatables-pt-br.json';

import Shepherd from 'shepherd.js';
window.Shepherd = Shepherd;

import { Loader } from "@googlemaps/js-api-loader";
window.GoogleMapsLoader = Loader;

import LeafLet from 'leaflet'
window.LeafLet = LeafLet;

import LeafLetMarkercluster from 'leaflet.markercluster'
window.LeafLetMarkercluster = LeafLetMarkercluster;

require('./data-loader.js');
require('./handle-save.js');
require('./handle-synchronizer-bar.js');
require('./data-loader.js');

//window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*
const app = new Vue({
    el: '#app',
});
*/
